import {useEffect, useState} from 'react';
import {
  Box,
  Typography,
  styled,
  useTheme,
  Card as MuiCard,
  Grid,
  useMediaQuery,
} from '@mui/material';
import {useIsCustomWidth, useIsLargeDevice} from '@jobseeker/lotus/hooks';
import {UserProfileCardProps} from '../type';
import Avatar from '@jobseeker/lotus/components/Avatar';
import CardOverlay from './overlay';
import ProgressBar from '@jobseeker/lotus/elements/ProgressBar';
import LinkSection from './LinkSection';
import Pro from '@jobseeker/lotus/elements/Pro';
import {getOldLink, truncateString} from '@jobseeker/lotus/utils';
import {openUrl} from '@jobseeker/common-core/utils/common';
import {ButtonV2} from '@jobseeker/lotus/elements';
import dynamic from 'next/dynamic';

const BottomSheet = dynamic(
  () => import('@jobseeker/lotus/elements/BottomSheet'),
  {ssr: false}
);

const Card = styled(MuiCard)<any>(({theme}: any) => ({
  borderRadius: theme.spacing(2),
  position: 'relative',
  // padding: theme.spacing(2),
}));

const Component = (props: UserProfileCardProps) => {
  const theme = useTheme();
  const [expand, setExpand] = useState(false);
  // const sheetRef = useRef<BottomSheetRef>();
  const isLarge = useIsLargeDevice();
  useEffect(() => {});

  const toggleAcordion = () => {
    setExpand(prev => !prev);
  };

  const isXXS = useIsCustomWidth('xs');

  return (
    <>
      <Card>
        <CardOverlay height={78} />
        <Box sx={{p: theme.spacing(2, 2, 1, 2)}}>
          <Card
            sx={{
              mt: 3.5,
              overflow: 'visible',
              // boxShadow: 2,
              boxShadow: '5px 9px 20px 3px rgba(19, 21, 23, 0.04)',
              textOverflow: 'ellipsis',
              // textAlign: 'center',
              // pb: 2,
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                zIndex: 2,
                left: 16,
                display: 'flex',
                justifyContent: 'center',
                mt: '-20px',
              }}
            >
              <Box sx={{p: 0.5, background: '#ffffff33', borderRadius: '100%'}}>
                <Avatar
                  imgUrl={props.profileImgUrl}
                  showFallbackIcon={true}
                  sx={{width: 60, height: 60}}
                  onClick={() => {
                    openUrl(
                      getOldLink(
                        '/registration/addPersonalDetails?ref=profilewdg'
                      ),
                      '_self'
                    );
                  }}
                />
              </Box>
            </Box>
            <Box
              sx={{
                p: 1,
                pt: 1.5,
                ml: 10,
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                color: 'primary.main',
              }}
            >
              <Typography
                color="secondary"
                variant="subtitle2"
                lineHeight={1}
                fontWeight={600}
                display={'flex'}
              >
                {truncateString(props.name, isXXS ? 16 : 24)}
                {props?.isProMember && (
                  <Box display="block" ml={theme.spacing(0.5)}>
                    <Pro bgColor="linear-gradient(180deg, #FFB743 0%, #F99914 100%)" />
                  </Box>
                )}
              </Typography>
              {props.professionalStatus ? (
                <>
                  {props.professionalStatus === 'has_role' &&
                    props.subtitle && (
                      <Typography
                        color="secondary"
                        variant="body3"
                        fontSize={{xxs: 13, sm: 12}}
                        sx={{
                          display: '-webkit-box',
                          WebkitLineClamp: 3,
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden',
                        }}
                      >
                        {props.subtitle}
                      </Typography>
                    )}
                  {props.professionalStatus === 'needs_profile' && (
                    <Typography
                      component="button"
                      type="button"
                      onClick={props.onBuildProfileClick}
                      variant="body3"
                      fontSize={{xxs: 13, sm: 12}}
                      sx={{
                        color: 'primary.main',
                        fontWeight: 600,
                        border: 'none',
                        background: 'none',
                        p: 0,
                        cursor: 'pointer',
                        textAlign: 'left',
                      }}
                    >
                      Build your profile
                    </Typography>
                  )}
                </>
              ) : (
                props.email && (
                  <Typography
                    color="secondary"
                    variant="body3"
                    fontSize={{xxs: 13, sm: 12}}
                    sx={{
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {props.email}
                  </Typography>
                )
              )}
              {!props?.isProMember && (
                <Box display={'block'} py={1}>
                  <ButtonV2
                    sx={{
                      display: {md: 'none'},
                      fontSize: theme.typography.pxToRem(10),
                      fontWeight: 500,
                      lineHeight: '15px',
                      letterSpacing: '0.4px',
                      padding: '4px 16px',
                      borderRadius: 4,
                      boxShadow: '5px 9px 20px 3px rgba(19, 21, 23, 0.04)',
                      borderColor: '#FFB743 !important',
                      ':hover': {
                        backgroundColor: '#fff',
                      },
                    }}
                    variant="outlined"
                    size="large"
                    style={{
                      color: '#FFB743',
                    }}
                    onClick={event => {
                      event?.preventDefault();
                      openUrl(props?.proMemberUrl || '', '_self');
                    }}
                  >
                    Upgrade to PRO
                  </ButtonV2>
                </Box>
              )}
            </Box>
          </Card>
          <Grid container sx={{mt: 1.3, mb: 0.3}}>
            <Grid item xxs={8}>
              <ProgressBar value={props.profileProgress} barColor="#EDBB4A" />
            </Grid>

            <Grid item xxs={4} sx={{textAlign: 'right'}}>
              <Typography
                onClick={toggleAcordion}
                sx={{
                  cursor: 'pointer',
                  color: 'primary.main',
                  fontSize: '14px',
                }}
              >
                Edit Profile
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Card>
      <BottomSheet
        title="Edit Profile"
        open={expand}
        onDismiss={toggleAcordion}
      >
        <Box sx={{px: 1.5, py: 3}}>
          <LinkSection {...props} />
        </Box>
      </BottomSheet>
    </>
  );
};

export default Component;
